<div class="layout-menu-container pt-4 flex flex-column justify-content-between">

  <div>
    <div *ngFor="let item of items" class="flex align-items-center menu-item cursor-pointer" style="padding: 0.8rem 0 0.8rem 1rem"
         [routerLink]="item.routerLink" [routerLinkActiveOptions]="{exact: true}" routerLinkActive="menu-item-active">
      <div>
        <i class="pi {{item.icon}}" style="font-size: 17px"></i>
      </div>
      <div class="ml-3" style="font-size: 16px">
        {{item.label}}
      </div>
    </div>
  </div>

  <div class="flex flex-column align-items-center mb-6 pb-6">
    <div class="mb-2 text-center" style="letter-spacing: 5px">BY IOTSENS</div>
  </div>

</div>
